import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconSingleTick: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#b0b0b0',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 -960 960 960"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
      fill={color}
    />
  </svg>
);

export default IconSingleTick;
